import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './component/ErrorBoundary/ErrorBoundary';

const ReactNotifications = React.lazy(() =>
  import('react-notifications-component').then((m) => {
    import('react-notifications-component/dist/theme.css');
    return { default: m.ReactNotifications };
  })
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <Suspense fallback={null}>
      <ReactNotifications />
    </Suspense>
    <App />
  </ErrorBoundary>
);

reportWebVitals();
